/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_Ingest_Attachments_SuccessInputs */

const es_tools_outlook_ingest_attachments_success = /** @type {(inputs: Tools_Outlook_Ingest_Attachments_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjuntos de Outlook ingestados`)
};

const en_tools_outlook_ingest_attachments_success = /** @type {(inputs: Tools_Outlook_Ingest_Attachments_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outlook attachments ingested`)
};

/**
* | output |
* | --- |
* | "Outlook attachments ingested" |
*
* @param {Tools_Outlook_Ingest_Attachments_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_ingest_attachments_success = /** @type {((inputs?: Tools_Outlook_Ingest_Attachments_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_Ingest_Attachments_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_ingest_attachments_success(inputs)
	return en_tools_outlook_ingest_attachments_success(inputs)
});
export { tools_outlook_ingest_attachments_success as "tools.outlook.ingest_attachments_success" }